import { Directive, ElementRef, AfterViewInit, Input, HostListener, Renderer2 } from "@angular/core";
declare var $: any;

@Directive({
  selector: '[perfect-scrollbar]'
})
export class PerfectScrollbarDirective implements AfterViewInit {
  @Input('perfect-scrollbar') perfectScrollbar: boolean;

  get applyPerfectScroll(): boolean {
    // if it's a string, that's because we didn't pass a value
    return (typeof this.perfectScrollbar === 'boolean') ? this.perfectScrollbar : true;
  }

  constructor(private element: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit() {
    if (this.applyPerfectScroll) {
      let selectClass: string = '.' + this.element.nativeElement.className;
      selectClass = selectClass.replace(/\ /g, '.');
      this.renderer.setStyle(this.element.nativeElement, 'overflow', 'hidden');
      $(selectClass).perfectScrollbar({
        suppressScrollY: selectClass.indexOf('horizontal-scroll') != -1,
        suppressScrollX: selectClass.indexOf('table-responsive') == -1  && selectClass.indexOf('horizontal-scroll') == -1, //Show only for table responsive and horizontal-scroll
        minScrollbarLength: 50
      });
      $(selectClass).perfectScrollbar('update');
    }
  }

  @HostListener('window:resize', ['$event'])
  private onWindowResize(evt: Event): void {
    if (this.applyPerfectScroll) {
      let selectClass: string = '.' + this.element.nativeElement.className;
      selectClass = selectClass.replace(/\ /g, '.');
      $(selectClass).perfectScrollbar('update');
    }
  }

}
